import { motion } from "framer-motion";
import { Star, ShieldCheck, Clock, ThumbsUp } from "lucide-react";

const items = [
  { icon: ShieldCheck, label: "Assurance décennale" },
  { icon: Clock, label: "Devis sous 48h" },
  { icon: ThumbsUp, label: "+200 chantiers réalisés" },
];

const TrustBanner = () => (
  <section className="bg-muted border-y border-border overflow-hidden">
    <div className="container-custom px-4 py-5 md:py-6">
      <div className="flex flex-wrap items-center justify-center gap-8 md:gap-14">
        {items.map((item, i) => (
          <motion.div
            key={item.label}
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.12, duration: 0.4 }}
            className="flex items-center gap-2.5"
          >
            <item.icon size={20} className="text-primary" />
            <span className="text-foreground text-sm font-medium">{item.label}</span>
          </motion.div>
        ))}

        {/* Google Rating */}
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.36, duration: 0.4 }}
          className="flex items-center gap-2"
        >
          <div className="flex">
            {[1, 2, 3, 4, 5].map(i => (
              <Star key={i} size={16} className="text-primary fill-primary" />
            ))}
          </div>
          <span className="font-heading font-bold text-foreground text-sm">5/5</span>
          <span className="text-muted-foreground text-sm">Google</span>
        </motion.div>
      </div>
    </div>
  </section>
);

export default TrustBanner;
